import Vue from 'vue'
import Element from 'element-ui'
import '../assets/css/element-variables.scss'
import Contextmenu from "vue-contextmenujs"
Vue.use(Contextmenu);
Vue.use(Element)
